import { Resource } from "../resourcesSlice";
import {
  EditableResourceDetailsProps,
} from "./MailResourceHelpers";
import {
  ResourceDetailCardBase,
  TableFormElement,
} from "./ResourceDetailCardBase";
import { dropdown } from "./FormHelpers";
import { MattermostTeamResource } from "../../../proto/sip/resources/resources_pb";
import { GetStringForMattermostTeamMode } from "../../../util/resourcesProto";
import * as Yup from "yup";

const tableElements: TableFormElement<Resource>[] = [
  {
    title: "Mattermost Team",
    key: "mattermostTeam.team" as keyof Resource,
    validation: Yup.string().required(),
  },
  {
    title: "Sync Mode",
    key: "mattermostTeam.mode" as keyof Resource,
    formatter: GetStringForMattermostTeamMode,
    customFieldInputElement: dropdown([MattermostTeamResource.TeamMode.STRICT, MattermostTeamResource.TeamMode.ADD], GetStringForMattermostTeamMode),
  },
];

export const MattermostTeam = (
  props: EditableResourceDetailsProps<Resource>
) => (
  <ResourceDetailCardBase {...props}>{tableElements}</ResourceDetailCardBase>
);

export const mattermostTeamTableElements = tableElements;

